import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import ukTranslations from './locales/uk.json';
import plTranslations from './locales/pl.json';

// Get language from localStorage or default to Ukrainian
const getStoredLanguage = () => {
  try {
    const stored = localStorage.getItem('language');
    if (stored && ['uk', 'en', 'pl'].includes(stored)) {
      return stored;
    }
  } catch (e) {
    console.warn('Failed to read language from localStorage:', e);
  }
  return 'uk';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      uk: { translation: ukTranslations },
      pl: { translation: plTranslations },
    },
    lng: getStoredLanguage(),
    fallbackLng: 'uk',
    supportedLngs: ['uk', 'en', 'pl'],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;




